import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
  max-width: 1280px;
  max-height: 773px;
  padding-top: 20px;
`;

export const QRCodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 16px;

  > p {
    &:first-of-type {
      ${({ theme }) => theme.typography.SEMI_BOLD_24};
      color: ${({ theme }) => theme.color[2]};
      margin-top: 200px;
      margin-bottom: 12px;
    }

    &:nth-of-type(2) {
      ${({ theme }) => theme.typography.MEDIUM_16};
      color: ${({ theme }) => theme.color[2]};
    }
  }

  > div {
    width: 100%;
    height: 40px;
    ${({ theme }) => theme.typography.SEMI_BOLD_48};
    color: ${({ theme }) => theme.color[2]};
    line-height: 40px;
  }
`;

export const QRCode = styled.img`
  width: 320px;
  height: 320px;
  margin-top: 36px;
  margin-bottom: 32px;
`;
